import { useEffect, useState } from 'react'
import { getTeamleden } from '../lib/supabase'

export default function TeamTab() {
  const [team, setTeam] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getTeamleden()
      .then(data => setTeam(data))
      .catch(() => setTeam([]))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="spinner" />

  if (team.length === 0) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: '32px 16px' }}>
        <p style={{ color: 'var(--muted)', fontSize: 13 }}>Geen teamleden gevonden.</p>
      </div>
    )
  }

  return (
    <div>
      <div className="card" style={{ marginBottom: 12 }}>
        <p style={{ fontFamily: 'Montserrat', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--muted)', marginBottom: 4 }}>
          Ons team
        </p>
        <p style={{ fontSize: 13, color: 'var(--text)', lineHeight: 1.5 }}>
          Maak kennis met de mensen achter Vitaal Sterk.
        </p>
      </div>

      {team.map(lid => (
        <div key={lid.id} className="card" style={{ marginBottom: 10 }}>
          <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
            {lid.foto_url ? (
              <img
                src={lid.foto_url}
                alt={lid.naam}
                style={{ width: 64, height: 64, borderRadius: 12, objectFit: 'cover', flexShrink: 0 }}
              />
            ) : (
              <div className="avatar" style={{ width: 64, height: 64, fontSize: 22, borderRadius: 12, flexShrink: 0 }}>
                {lid.naam.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()}
              </div>
            )}
            <div style={{ flex: 1 }}>
              <p style={{ fontFamily: 'Montserrat', fontWeight: 700, fontSize: 15, color: 'var(--text)', marginBottom: 2 }}>
                {lid.naam}
              </p>
              {lid.functie && (
                <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--orange)', marginBottom: 8 }}>
                  {lid.functie}
                </p>
              )}
            </div>
          </div>
          {lid.motivatie && (
            <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.65, marginTop: 12, borderTop: '1px solid var(--border)', paddingTop: 10 }}>
              "{lid.motivatie}"
            </p>
          )}
        </div>
      ))}
    </div>
  )
}
